import { TriangleDownIcon, XCircleFillIcon } from "@primer/octicons-react";
import { Box, Button, IconButton, SelectPanel } from "@primer/react";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useCommonContext } from "../../contexts/common";
import { RootState } from "../../state/reducers";
import { useMonths } from "../../hooks/useMonths";
import { ePageBaseStatus } from "../../models/ePageBaseStatus";
import { actions } from "../../state/actions/actionsWrapper";
import { useCommonSelectedHook } from "../../hooks/useCommonSelectedHook";

type IComboboxThangProps = {
  isReadonly?: boolean;
  value?: number;
  hoc_ky?: number;
  onValueChanged: (id: number) => void;
  className?: string;
  isShowClearButton?: boolean;
  preText?: string;
  width?: any;
  stylingMode?: "outlined" | "filled" | "underlined";
};

export const ComboboxThang = (props: IComboboxThangProps) => {
  const { thangs } = useMonths();
  const { dm_truong_id, nam_hoc } = useCommonSelectedHook();
  let stylingMode = "outlined";
  if (props.stylingMode) stylingMode = props.stylingMode;
  const { pl_hockys, status: statusHocKy } = useSelector((x: RootState) => x.danhMucWrapper.hocKy)
  const { language } = useSelector((x: RootState) => x.common);
  const [open, setOpen] = useState(false)
  const [filter, setFilter] = useState('')
  const dispatch = useDispatch();
  const source = useMemo(() => {

    if (!props.hoc_ky) return thangs;
    if (props.hoc_ky) {
      // debugger
      const hocKyConfig = pl_hockys.find(x => x.hoc_ky === `${props.hoc_ky}`);
      if (hocKyConfig && hocKyConfig.tu_ngay && hocKyConfig.den_ngay) {
        var tuThang = new Date(hocKyConfig.tu_ngay).getMonth() + 1;
        var denThang = new Date(hocKyConfig.den_ngay).getMonth() + 1;
        let result: any[] = [];
        thangs.sort((a, b) => a.idx - b.idx).forEach(thang => {
          if ((thang.id >= tuThang && thang.id <= denThang) || (denThang < tuThang && thang.id >= tuThang)
            || (denThang < tuThang && thang.id <= denThang)
          ) {
            result.push(thang)
          }
        })
        return result;
      }
      return thangs;
    }
    // if (props.hoc_ky == 1) return thangs.filter(x => x.id >= 8 && x.id <= 12)
    // if (props.hoc_ky == 2) return thangs.filter(x => x.id >= 1 && x.id <= 6)
  }, [thangs, props.hoc_ky, pl_hockys])
  useEffect(() => {
    if (statusHocKy === ePageBaseStatus.is_not_initialization) {
      dispatch(actions.danhMucWrapper.hocKy.loadStart({
        dm_truong_id,
        nam_hoc
      }))
    }
  }, [statusHocKy])
  const dataSource = useMemo(() => {
    if (source) {
      return source.map(x => ({ id: x.id, text: language === "en" ? x.thang_en : x.thang }))
    }
    return [];
  }, [source, language])
  const filteredItems = useMemo(() => {
    return dataSource.filter(item => item.text.toLowerCase().includes(filter.toLowerCase()))
  }, [dataSource, filter])
  //nếu selected= obj -> chọn 1, = array -> chọn nhiều
  const selected = useMemo(() => {
    return dataSource.find(x => x.id == props.value)
  }, [dataSource, props.value])
  const setSelected = (selecteds: any) => {
    if (selecteds)
      props.onValueChanged(selecteds.id)
  }

  const { translate } = useCommonContext();
  return (
    <SelectPanel
      renderAnchor={({ children, 'aria-labelledby': ariaLabelledBy, ...anchorProps }) => (
        <Box sx={{
          display: "flex"
        }}>
          <Button sx={{ flex: 1 }} trailingAction={TriangleDownIcon} aria-labelledby={` ${ariaLabelledBy}`} {...anchorProps}>
            {children || translate("ComboboxThang.PlaceHolder")}
          </Button>
          {props.isShowClearButton && props.value != undefined && props.value > 0 &&
            <IconButton aria-label={"Clear"} icon={XCircleFillIcon}
              variant="invisible"
              onClick={() => {
                props.onValueChanged(0)
              }}
            ></IconButton>
          }
        </Box>


      )}
      title={""}
      placeholderText="Search"
      open={open}
      onOpenChange={setOpen}
      items={filteredItems}
      selected={selected}
      onSelectedChange={setSelected}
      onFilterChange={setFilter}
      showItemDividers={false}
      overlayProps={{ width: 'auto', height: 'auto' }}
    />
    // <SelectBox
    //   dataSource={dataSource}
    //   displayExpr={language == "en" ? "thang_en" : "thang"}
    //   valueExpr={"id"}
    //   value={props.value}
    //   stylingMode={
    //     props.stylingMode != undefined ? props.stylingMode : "outlined"
    //   }
    //   readOnly={props.isReadonly === true}
    //   placeholder={translate("Base.Label.SelectMonth")}
    //   width={props.width ? props.width : "100%"}
    //   className={
    //     "default_selectbox " + (props.className ? props.className : "")
    //   }
    //   showClearButton={props.isShowClearButton === true}
    //   onValueChanged={(e) => {
    //     if (e.event) props.onValueChanged(e.value);
    //   }}
    // />
  );
};
